import { BookingExperiences } from './booking-experiences.model';

export class Experiences {
  id: number;
  name: string;
  price: number;
  description: string;
  discount: number;
  highlights: string;
  included: string;
  excluded: string;
  excursion: string;
  duration: string;
  picture: string;
  pictureAlt: string;
  metaKeywords: string;
  maximumCapacity: number;
  adminApproval: string;
  active: boolean;
  videoUrl: string;
  index: string;
  verified: boolean;
  startIndex: number;
  startDate: string;
  endDate: string;
  createdBy: string;
  cityId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  BookingExperiences: BookingExperiences;

  constructor() {
    this.id = null;
    this.name = '';
    this.price = null;
    this.description = null;
    this.discount = null;
    this.highlights = '';
    this.included = '';
    this.excluded = '';
    this.excursion = '';
    this.duration = '';
    this.picture = '';
    this.pictureAlt = '';
    this.metaKeywords = '';
    this.maximumCapacity = null;
    this.adminApproval = '';
    this.active = null;
    this.videoUrl = '';
    this.index = '';
    this.verified = null;
    this.startIndex = null;
    this.startDate = '';
    this.endDate = '';
    this.createdBy = '';
    this.cityId = '';
    this.createdAt = '';
    this.updatedAt = '';
    this.deletedAt = '';
  }
}
